import { Component, ElementRef, Input, OnChanges, OnInit, Renderer2, SecurityContext, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { encapsulation } from '../encapsulation';
import { UBXSvgService } from '../../services';

@Component({
    selector: 'ubx-icon',
    templateUrl: './icon.component.html',
    host: { class: 'ubx-icon flx f-jc:c f-ai:c' },
    encapsulation
})
export class UBXIconComponent implements OnInit, OnChanges {
    @Input() svg: string;
    @Input() color: string;
    @Input() size: string;

    noIcon: boolean;

    constructor(
        private renderer: Renderer2,
        private el: ElementRef,
        private domSanitizer: DomSanitizer,
        private svgService: UBXSvgService,
    ) { }

    ngOnInit() {
        this.setSvg(this.svg);
        this.setSize(this.size);
        this.setColor(this.color);
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.svg && changes.svg.previousValue) {
            this.setSvg(changes.svg.currentValue);
        }
    }

    private setSvg(svg: string) {
        let cat: string;
        let icn: string;
        let shp = '';
        let wgh = 'sld';

        if (svg) {
            const split = svg.split(' ');
            if (split[0]) {
                cat = split[0].split('.')[0];
                icn = split[0].split('.')[1];
            }
            if (split[1]) {
                shp = split[1].split('.')[0];
                wgh = split[1].split('.')[1];
            }
            this.svgService.getIcons(cat, icn, shp, wgh).subscribe((resp) => {
                const trustHtml = this.domSanitizer.bypassSecurityTrustHtml(resp);
                const icon: SafeHtml = this.domSanitizer.sanitize(SecurityContext.HTML, trustHtml);
                this.el.nativeElement.innerHTML = icon;
            }, (error) => {
                this.noIcon = true;
                // this.appendClass(error.error.type);
            });
        }
    }
    private setSize(size: string) {
        if (size) {
            size.split(' ').forEach((val, i) => {
                this.appendClass(`fs:${val}`);
            });
        }
    }
    private setColor(color: string) {
        if (color) {
            color.split(':').forEach((val, i) => {
                const value = i === 0 ? val : `${val}:hvr`;
                this.appendClass(`clr:${value}`);
            });
        }
    }

    private appendClass(name: string) {
        this.renderer.addClass(this.el.nativeElement, name);
    }

}
